import Superagent from 'superagent'
import Storage from './storage.service'
import Access from '../$methods/access.methods'

const { HOST_API } = _CONSTANTS_

export default {
    getInvoices,
    getClient,
    createClient,
    getInvoiceAmount,
    createInvoice,
    updateClient
}

function getInvoices(userId) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/facturama/invoices`)
            .set('access', Storage.getItem('access'))
            .query({ userId })
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getInvoiceAmount(userId) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset() / 60

        Superagent
            .get(`${HOST_API}/facturama/invoices/amount`)
            .set('access', Storage.getItem('access'))
            .query({ timezone, userId })
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function getClient(userId, facturamaId) {
    return new Promise((resolve, reject) => {
        Superagent
            .get(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({ userId, facturamaId })
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createClient(data) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({ userId: data.userId })
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}

function createInvoice(data, userId) {
    return new Promise((resolve, reject) => {

        const timezone = new Date().getTimezoneOffset()/60

        Superagent
            .post(`${HOST_API}/facturama/invoices`)
            .set('access', Storage.getItem('access'))
            .query({timezone})
            .query({userId})
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}


function updateClient(data, userId) {
    return new Promise((resolve, reject) => {
        Superagent
            .put(`${HOST_API}/facturama/clients`)
            .set('access', Storage.getItem('access'))
            .query({userId})
            .send(data)
            .end((err, res) => {
                Access(res.body)
                resolve(res.body)
            })
    })
}
